// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 26px;
  padding-inline: 14px;
  background-color: var(--ion-color-tertiary);
  border-radius: 1px;
}
.chip p {
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #FFFBE1;
}
.chip .table {
  margin-right: 3px;
}
.chip ion-icon {
  margin-left: 5px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chip-table/chip-table.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,2CAAA;EACA,kBAAA;AACF;AACE;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AAME;EACE,gBAAA;EACA,YAAA;AAJJ","sourcesContent":[".chip {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 26px;\n  padding-inline: 14px;\n  background-color: var(--ion-color-tertiary);\n  border-radius: 1px;\n\n  p {\n    font-family: AppFontMedium;\n    font-size: 12px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    vertical-align: middle;\n    text-transform: capitalize;\n    color: #FFFBE1;\n  }\n\n  .table {\n    margin-right: 3px;\n  }\n\n  .number {\n  }\n\n  ion-icon {\n    margin-left: 5px;\n    color: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
